import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

export const Route = createFileRoute('/_authenticated')({
  head: () => ({
    meta: [{ title: 'Área Autenticada' }],
  }),
  onError: () => {
    return <div>Something went wrong</div>;
  },
  beforeLoad: async ({ location }) => {
    const { session } = useAuthSessionStore.getState();

    if (!session) {
      throw redirect({
        to: '/auth/signin',
        search: {
          redirect: location.href,
        },
      });
    }
  },
});
